module.exports = __webpack_public_path__ + "img/1.ded80b65.jpg";